export const MIDDLE_OFFICE_BASE_PATH = 'middle-office';
